import { Logger } from './Logger';

export const logger = new Logger();
